import { render } from "./Create-new-zip-code.vue?vue&type=template&id=0787a192&scoped=true"
import script from "./Create-new-zip-code.vue?vue&type=script&lang=js"
export * from "./Create-new-zip-code.vue?vue&type=script&lang=js"

import "./Create-new-zip-code.vue?vue&type=style&index=0&id=0787a192&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0787a192"]])

export default __exports__